import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";
import { withAuthRetry } from "../lib/authState";

const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const { user } = useAuth();
  const [wallet, setWallet] = useState(null);
  const [usage, setUsage] = useState(null);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!user) return setWallet(null);
    const cached = JSON.parse(localStorage.getItem(`dropit-wallet-${user.id}`) || "null");
    if (cached) setWallet((w) => w ?? cached);
    const { data, error } = await withAuthRetry(() => supabase.from("user_wallets").select("*").eq("user_id", user.id).maybeSingle());
    if (error) { setError(error.message); return; }
    setWallet(data); if (data) localStorage.setItem(`dropit-wallet-${user.id}`, JSON.stringify(data));
    if (data?.subscription_status === "active" || data?.subscription_status === "past_due") {
      const { data: u } = await supabase.rpc("monthly_usage");
      setUsage(Array.isArray(u) ? u[0] : u);
    } else setUsage(null);
  }, [user]);

  useEffect(() => {
    refresh();
    if (!user) return;
    const channel = supabase.channel(`wallet-${user.id}`)
      .on("postgres_changes", { event: "*", schema: "public", table: "user_wallets", filter: `user_id=eq.${user.id}` }, (p) => setWallet(p.new))
      .subscribe();
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus); window.addEventListener("dropit-synced", onFocus);
    return () => { supabase.removeChannel(channel); window.removeEventListener("focus", onFocus); window.removeEventListener("dropit-synced", onFocus); };
  }, [user, refresh]);

  return <WalletContext.Provider value={{ wallet, usage, error, refresh }}>{children}</WalletContext.Provider>;
}

export const useWallet = () => useContext(WalletContext);
